import {SavedCartListComponent} from "@spartacus/cart/saved-cart/components";
import {ChangeDetectionStrategy, Component, ElementRef, ViewChild} from "@angular/core";
import {GonvarriCartEntry} from "../../core/models/gonvarri-cart-entry.model";
import {ICON_TYPE} from "@spartacus/storefront";
import {Cart} from "@spartacus/cart/base/root";
import {SavedCartFormType} from "@spartacus/cart/saved-cart/root";
import {take} from "rxjs/operators";
import {Subscription} from "rxjs";
import { LAUNCH_CALLER } from "src/app/core/models/saved-cart/gonvarri-augmented-core.model";

@Component({
    selector: 'cx-saved-cart-list',
    templateUrl: './gonvarri-saved-cart-list.component.html',
    styleUrl: './gonvarri-saved-cart-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GonvarriSavedCartListComponent extends SavedCartListComponent {

  protected gonvarriSubscription = new Subscription();
  savedCartFormType = SavedCartFormType;
  @ViewChild('elementDelete') deleteButtonElement: ElementRef = {} as ElementRef;

  getSavedCartWeight(cart: any): number {
    return cart.entries?.reduce((acc: number, cur: GonvarriCartEntry) => acc + (Number(cur.packageWeight) * ((cur.product?.code?.includes("_p")) ? Number(cur.numberOfSheets) : 1) * Number(cur.quantity)), 0);
  }

  deleteSavedCart(cart: Cart): void {
    this.openDeleteDialog(cart);
  }

  openDeleteDialog(cart: Cart): void {
    const dialog = this.launchDialogService.openDialog(
      LAUNCH_CALLER.SAVED_CART,
      this.deleteButtonElement,
      this.vcr,
      { cart, layoutOption: this.savedCartFormType.DELETE }
    );

    if (dialog) {
      this.gonvarriSubscription.add(dialog.pipe(take(1)).subscribe());
    }
  }

  protected readonly ICON_TYPE = ICON_TYPE;
}
